/*
 * @Author: lixin jiang
 * @Date: 2021-07-13 19:53:34
 * @LastEditTime: 2021-07-13 19:54:58
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/GroupButton/index.js
 * @
 */

import GroupButton from './groupButton';

export default GroupButton;
